<template>
  <button class="btn btn-primary btn-sm" @click.prevent="editEntity()">
    <font-awesome-icon :icon="['fal', 'pencil']" />
  </button>
</template>

<script type="text/babel">
export default {
  props: ["entity", "entityName"],

  methods: {
    editEntity() {
      this.$router.push({
        name: `${this.entityName}.edit`,
        params: { id: this.entity.id },
      });
    },
  },
};
</script>
